import React from "react";
import { LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import AppLogo from "./AppLogo";
interface LoadingComponentProps {
  Icon?: LucideIcon;
  title: string;
  message?: string;
  error?: boolean;
}

const LoadingComponent: React.FC<LoadingComponentProps> = ({
  Icon,
  title,
  message = "fetching-data",
  error = false,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={
        error
          ? "bg-transparent py-4 sm:py-8 px-4 flex items-center justify-center"
          : `min-h-screen bg-[#f2e6db] py-4 sm:py-8 px-4 flex items-center justify-center`
      }
    >
      <div className="text-center">
        <div className="relative w-24 h-24 mx-auto mb-6">
          {!error && (
            <div className="absolute inset-0 border-4 border-gray-700 rounded-full animate-ping"></div>
          )}
          {!error && (
            <div className="absolute inset-0 border-4 border-t-gray-600 border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin"></div>
          )}
          {Icon ? (
            <Icon className="w-24 h-24 text-gray-700 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-0 m-0" />
          ) : (
            <AppLogo className="w-24 h-24 text-gray-700 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  p-0 m-0" />
          )}
        </div>

        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          {t("Loading")} {t(title)}
        </h2>
        <p className="text-gray-600">{t(message)}</p>
      </div>
    </div>
  );
};

export default LoadingComponent;
